var _rect, _rect2, _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 28,
    viewBox: "0 0 60 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 58.0797,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 58.0797,
    height: 27,
    rx: 13.5,
    stroke: "#89D9CE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6985_1406845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7273 6.5708L14.9084 11.431L20.2045 12.0034L16.2562 15.5795L17.3485 20.7935L12.7273 18.1434L8.106 20.7935L9.19832 15.5795L5.25 12.0034L10.5461 11.431L12.7273 6.5708Z",
    fill: "#2BA695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7266 13.6821L17.3478 20.7935L12.7266 18.1434V13.6821Z",
    fill: "#93E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7267 13.6821L8.10547 20.7935L9.19779 15.5794L12.7267 13.6821Z",
    fill: "#93E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7273 13.6823L10.5461 11.4312L5.25 12.0036L12.7273 13.6823Z",
    fill: "#93E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7266 13.6823L14.9077 11.4312L20.2038 12.0036L12.7266 13.6823Z",
    fill: "#93E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.728 6.5708L10.5469 11.431L12.728 13.6822V6.5708Z",
    fill: "#93E9DE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0559 18.2134H29.9234V19.7275H24.1797V8.28941H26.0559V18.2134Z",
    fill: "#2BA695"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3686 8.28941V19.7275H31.4924V8.28941H33.3686Z",
    fill: "#2BA695"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2214 8.28941V9.81997H40.1767V19.7275H38.3005V9.81997H35.2394V8.28941H43.2214Z",
    fill: "#2BA695"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9976 9.80351V13.1609H50.9475V14.6914H46.9976V18.1969H51.4412V19.7275H45.1214V8.27295H51.4412V9.80351H46.9976Z",
    fill: "#2BA695"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6985_1406845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2727,
    height: 15.2727,
    fill: "white",
    transform: "translate(5.08984 6.36377)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLite);
export default __webpack_public_path__ + "static/media/lite.51413a92e67b7970606f19a5d4d2e1f2.svg";
export { ForwardRef as ReactComponent };